export default __webpack_public_path__ + "static/media/howtoplayimage2.838cc80a.png";